export const dateJsonSchema = {
  type: 'object',
  properties: {
    orderDate: {
      type: 'string',
      description: 'OD',
    },
    expectedDeliveryDate: {
      type: 'string',
    },
    invoiceDate: {
      type: 'string',
    },
  },
}

export const dateUiSchema = {
  type: 'HorizontalLayout',
  className: 'order-date-filters',
  elements: [
    {
      type: 'Control',
      scope: '#/properties/orderDate',
      component: 'ReadOnlyFieldWithJson',
      label: 'Order Date',
    },
    {
      type: 'Control',
      scope: '#/properties/expectedDeliveryDate',
      component: 'ReadOnlyFieldWithJson',
      label: 'Expected Delivery Date',
    },
    {
      type: 'Control',
      scope: '#/properties/invoiceDate',
      component: 'ReadOnlyFieldWithJson',
      label: 'Invoice Date',
    },
  ],
}
